"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeDeep = void 0;

var isIterable = function isIterable(item) {
  return typeof item === 'object' && item !== null && !Array.isArray(item) && !Buffer.isBuffer(item);
};

var mergeDeep = function mergeDeep(dest) {
  var result = dest;

  if (!isIterable(result)) {
    return result;
  }

  for (var _len = arguments.length, srcs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    srcs[_key - 1] = arguments[_key];
  }

  for (var _i = 0, _srcs = srcs; _i < _srcs.length; _i++) {
    var src = _srcs[_i];

    for (var key in src) {
      if (isIterable(src[key])) {
        if (!result[key]) {
          result[key] = {};
        }

        exports.mergeDeep(result[key], src[key]);
      } else if (src[key] !== undefined && src[key] !== null) {
        result[key] = src[key];
      }
    }
  }

  return result;
};

exports.mergeDeep = mergeDeep;